import { createRequestBuilder, HttpHeaders } from '@quickplay/foundation';
import { PlatformAuthorizer, AuthorizationUtil } from '@quickplay/platform-authorizer';
import { HeartbeatService } from '../HeartbeatService';
import { HeartbeatRequest } from '../model/HeartbeatRequest';
import { HeartbeatResponse } from '../model/HeartbeatResponse';

export const HEARTBEAT_TOKEN_HEADER_KEY = 'X-Heartbeat';

export function createHeartbeatServiceImpl(
  contentId: string,
  deviceId: string,
  heartbeatEndPointUrl: string,
  platform: PlatformAuthorizer,
  headers?: HttpHeaders,
): HeartbeatService {
  const heartbeatService: HeartbeatService = {
    headers: headers,

    heartbeat(token: string, offset?: number, cty?: string, prid?: string): Promise<HeartbeatResponse> {
      return heartbeat(token, offset, cty, prid);
    },
  };

  async function heartbeat(token: string, offset?: number, cty?: string, prid?: string): Promise<HeartbeatResponse> {
    try {
      const heartbeatRequest: HeartbeatRequest = {
        deviceId: deviceId,
        itemId: contentId,
        ...(offset && { offset: offset }),
        ...(cty && { cty: cty }),
        ...(prid && { prid: prid }),
      };
      const request = createRequestBuilder<HeartbeatRequest>()
        .url(heartbeatEndPointUrl)
        .path('/user/heartbeat/update')
        .post(heartbeatRequest)
        .headers({ accept: 'application/json', ...heartbeatService.headers, [HEARTBEAT_TOKEN_HEADER_KEY]: token })
        .build();
      const response = await AuthorizationUtil.makeAuthorizedRequest<HeartbeatRequest, HeartbeatResponse>(
        request,
        platform,
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return heartbeatService;
}
